module.exports = __webpack_public_path__ + "static/media/De Witt Clinton - 1812.09b94086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/De Witt Clinton - 1812.jpg
// module id = 454
// module chunks = 0